export default {
    getLabels: () => {
        return {
            url: '/groups/126/labels',
            method: 'GET',
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Labels/api.js